import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  loading: {
    height: 115,
    marginBottom: 12,
    marginTop: 12
  },
  screenshotTitle: {
    color: "#465869",
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 12
  },
  imageWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    margin: "12px 0 16px"
  },
  image: {
    height: 115,
    width: 210,
    borderRadius: 8,
    cursor: "pointer"
  },
  countImageButton: {
    height: 115,
    width: 210,
    background: "#f8fafc",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
    cursor: "pointer",
    "& > span": {
      fontWeight: 500,
      fontSize: 16,
      color: "#465869"
    }
  },
  drawer: {
    "& .MuiDrawer-paperAnchorRight": {
      maxWidth: 480
    }
  },
  drawerHeader: {
    backgroundColor: "#93a9bd",
    marginBottom: 16,
    "& > div": {
      padding: ".5rem 1.5rem",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "& > span": {
        color: "#fff",
        fontSize: 16,
        fontWeight: 700,
        fontFamily: "Manrope"
      },
      "& > svg": {
        cursor: "pointer"
      }
    }
  },
  uploadProgress: {
    height: 115,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    padding: "0 24px 24px",
    borderRadius: 8,
    opacity: 0.7,
    background: "#f8fafc",
    cursor: "default",
    "& > span": {
      fontSize: 14,
      fontWeight: 500,
      marginTop: 3
    },
    "&.withAnimation": {
      animation: `$bouncing 1s ease-in-out infinite`,
      marginTop: 12,
      marginBottom: 16
    }
  },
  "@keyframes bouncing": {
    "0%": {
      backgroundColor: "#f8fafc"
    },
    "50%": {
      backgroundColor: "#EDEFF1"
    },
    "100%": {
      backgroundColor: "#f8fafc"
    }
  }
}));

export default styles;
